import { Component, OnInit } from '@angular/core';

import {UserCreationService} from '../../shared/user-creation.service';

@Component({
  selector: 'app-customer-creation-grid',
  templateUrl: './customer-creation-grid.component.html',
  styleUrls: ['./customer-creation-grid.component.css'],
  providers : [UserCreationService]
})
export class CustomerCreationGridComponent implements OnInit {

  title="Customer List";
  constructor(private userCreation: UserCreationService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/masters/customer-creation-grid/customer-creation-grid.component.ts